import type React from 'react';
import { Alert } from '@itandi/itandi-bb-ui';
import { ProgressBar } from 'react-bootstrap';
import Styles from './ReportImageUploadPanel.module.scss';
import { TopArea } from './TopArea';

type Props = {
  uploading: boolean;
  deleting: boolean;
  progress: number;
  handleDrop: (files: File[]) => Promise<void>;
};

export const ReportImageUploadPanel: React.FC<Props> = ({
  uploading,
  deleting,
  progress,
  handleDrop
}: Props) => (
  <>
    {uploading && (
      <div className={Styles.ProgressBar}>
        <p className={Styles.Message}>
          <Alert variant="warning">
            現在写真をアップロード中です。
            <br />
            画面を移動すると、アップロードが正常に完了しない場合があります。
          </Alert>
        </p>
        <ProgressBar label={`${progress}%`} now={progress} />
      </div>
    )}
    {deleting && (
      <div className={Styles.DeleteProgressBar}>
        <p className={Styles.Message}>
          <Alert variant="warning">
            現在写真を削除中です。
            <br />
            画面を移動すると、削除が正常に完了しない場合があります。
          </Alert>
        </p>
        <ProgressBar label={`${progress}%`} now={progress} />
      </div>
    )}
    {!deleting && !uploading && <TopArea handleDrop={handleDrop} />}
  </>
);
